import React from "react"
import { Link } from "react-router-dom"



//Import Images
import errorImg from "../static/error.png"

const Pages404 = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: " space-evenly",

          flexWrap: "wrap",
        }}
      >
        <div className="ex-page-content">
          <h1 className="text-dark display-1 mt-4">404!</h1>
          <h4 className="mb-4">Sorry, page not found</h4>
          <p className="mb-5">
            It will be as simple as Occidental in fact, it will be Occidental to
            an English person
          </p>
          <Link to="/">
            <i className="mdi mdi-home">Back to main survey</i>
          </Link>
        </div>
        <div className="col-lg-2 ">
          <img
            src={errorImg}
            style={{
              height: "20vw",
        
            }}
            alt=""
            className="img-fluid mx-auto d-block"
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Pages404



// WEBPACK FOOTER //
// ./src/pages/pages-404.js